import React from "react";
import PropTypes from "prop-types";

//
import { Dropdown } from "react-bootstrap";
import Moment from "react-moment";
import ScrollBar from "react-perfect-scrollbar";

//
import ImageBox from "../general/ImageBox";

//
import { iconImage } from "../../redux/features/coins/actions";

function MobileTransactionList({
  symbol,
  items,
  delete_transaction,
  showEditTransactions,
}) {
  return (
    <div className="box-items">
      {items.map((item) => (
        <div className="items" key={item.id}>
          <header>
            <div className="d-flex">
              {/* <ImageBox src={iconImage(symbol)} /> */}
              <div>
                <p className="text-black fw-bolder">{symbol}</p>
                <small>type : {item.side.toUpperCase()}</small>
              </div>
            </div>
            <Dropdown align="end" className="edit-dropdown">
              <Dropdown.Toggle className="no-border">
                <i className="las la-ellipsis-v"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ScrollBar>
                  <Dropdown.Item onClick={() => delete_transaction(item.id)}>
                    <small className="text-danger d-flex align-items-center fw-bolder">
                      <i className="las la-trash text-danger"></i>
                      Delete
                    </small>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => showEditTransactions(item)}>
                    <small className="text-black d-flex align-items-center fw-bolder">
                      <i className="las la-edit"></i>
                      Edit
                    </small>
                  </Dropdown.Item>
                </ScrollBar>
              </Dropdown.Menu>
            </Dropdown>
          </header>
          <div className="content zebra">
            <div className="item">
              <small>Price</small>
              <div className="text-end">
                <small className="fw-bolder">${item.price}</small>
                <small className="fw-bolder">₿{item.btc_price}</small>
              </div>
            </div>

            <div className="item">
              <small>Quantity</small>
              <small className="fw-bolder">{item.quantity}</small>
            </div>

            <div className="item">
              <small>Date</small>
              <small>
                <span className="fw-bolder text-black">
                  <Moment utc format="MMM DD, YYYY, ">
                    {item.date}
                  </Moment>
                </span>
                <span>
                  <Moment utc format="hh:mm">
                    {item.date}
                  </Moment>
                </span>
              </small>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

MobileTransactionList.propTypes = {
  symbol: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  delete_transaction: PropTypes.func.isRequired,
  showEditTransactions: PropTypes.func.isRequired,
};

export default MobileTransactionList;
